import { createReducer } from "@reduxjs/toolkit";
import type { PayoutLessonVM } from "@shared-kernel/application/ports/shared/shared-repository";
import { retrieveTeacherPayoutLessons } from "./retrieve-payout-lessons";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<PayoutLessonVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveTeacherPayoutLessonsReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveTeacherPayoutLessons.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveTeacherPayoutLessons.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveTeacherPayoutLessons.rejected, state => {
      state.fetching = "failed";
    });
});
